import React, { Component } from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  children,
  href = 'https://www.impulsodigitalexpres.com/cart/49940485964022:1',
  onClick,
  className = ''
}: CTAButtonProps) {
  const Component = motion.a;
  return <Component href={href} onClick={onClick} className={`
        inline-block px-8 py-4 
        bg-cyan-500 hover:bg-cyan-400 
        text-black font-bold text-lg
        rounded-lg
        transition-colors duration-200
        shadow-[0_0_20px_rgba(0,217,255,0.5)]
        hover:shadow-[0_0_30px_rgba(0,217,255,0.7)]
        animate-pulse-glow
        ${className}
      `} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-19">
      {children}
    </Component>;
}